import { v4 as uuidv4 } from 'uuid';

export function handleFileDataSuccessHelper({
  fileData,
  setFileDetails,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setRestructuredErrors,
  setColumns,
}) {
  setFileDetails(fileData);
  setFullPageLoading(false);
  setFullPageLoadingTitle('');

  const restErr = {};

  (fileData.errors || []).forEach(el => {
    restErr[el.rowIndex] = {
      ...el,
      rowErrors: (el.rowErrors || []).map(r => ({ id: uuidv4(), value: r })),
      fileType: fileData.fileType,
    };
  });
  setRestructuredErrors(restErr);
  setColumns({ ...fileData.columns });
}

export async function handleFetchFileDetailsHelper({
  id,
  fetchFileDetails,
  handleFileDataSuccess,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setErrorTitle,
  setErrorDescription,
  setShowError,
}) {
  setFullPageLoadingTitle('Fetching File');
  setFullPageLoading(true);

  try {
    const fileData = await fetchFileDetails(id);

    if (fileData.success) {
      handleFileDataSuccess(fileData);
    } else {
      setFullPageLoading(false);
      setErrorTitle(fileData.title || 'Something went wrong');
      setErrorDescription(fileData.description || 'Please try again later');
      setShowError(true);
    }
  } catch (e) {
    setErrorTitle('Something went wrong');
    setErrorDescription('Please try again later');
    setShowError(true, e);
  }
}

export async function reUploadProceedHelper({
  reuploadFile,
  uploadFileRef,
  fileDetails,
  setShowConfirmModal,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setRestructuredErrors,
  setColumns,
  setFileDetails,
  setErrorTitle,
  setErrorDescription,
  setShowError,
}) {
  setShowConfirmModal(false);
  setFullPageLoading(true);
  setFullPageLoadingTitle('Re-uploading file');

  const {
    success,
    updatedRow = {},
    columns = {},
    title = 'Something went wrong',
    description = 'Please try again later',
  } = await reuploadFile(uploadFileRef.current, fileDetails.id);

  if (success) {
    setFullPageLoading(false);
    const restErr = {};

    (updatedRow.errors || []).forEach(el => {
      restErr[el.rowIndex] = {
        ...el,
        rowErrors: (el.rowErrors || []).map(r => ({ id: uuidv4(), value: r })),
        fileType: updatedRow.fileType,
      };
    });

    setRestructuredErrors(restErr);
    setColumns({ ...columns });
    setFileDetails(updatedRow);
  } else {
    setShowConfirmModal(false);
    setFullPageLoading(false);
    setErrorTitle(title);
    setErrorDescription(description);
    setShowError(true);
  }
}

export async function importProceedHelper({
  importFiles,
  fileDetails,
  setShowConfirmModal,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setFileDetails,
  setErrorTitle,
  setErrorDescription,
  setShowError,
}) {
  setShowConfirmModal(false);
  setFullPageLoading(true);
  setFullPageLoadingTitle('Importing file');

  const {
    success,
    importedFiles = {},
    title = 'Something went wrong',
    description = 'Please try again later',
  } = await importFiles([fileDetails]);

  if (success) {
    setFullPageLoading(false);
    setFileDetails(importedFiles[0]);
  } else {
    setFullPageLoading(false);
    setErrorTitle(title);
    setErrorDescription(description);
    setShowError(true);
    setShowConfirmModal(false);
  }
}

export async function validateProceedHelper({
  validateFiles,
  fileDetails,
  setShowConfirmModal,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setFileDetails,
  setRestructuredErrors,
  setErrorTitle,
  setErrorDescription,
  setShowError,
}) {
  setShowConfirmModal(false);
  setFullPageLoading(true);
  setFullPageLoadingTitle('Validating File');

  const {
    success,
    validatedFiles = {},
    title = 'Something went wrong',
    description = 'Please try again later',
  } = await validateFiles([fileDetails]);

  if (success) {
    setFileDetails(validatedFiles[0]);

    const restErr = {};

    (validatedFiles[0].errors || []).forEach(el => {
      restErr[el.rowIndex] = {
        ...el,
        rowErrors: (el.rowErrors || []).map(r => ({ id: uuidv4(), value: r })),
        fileType: validatedFiles[0].fileType,
      };
    });

    setRestructuredErrors(restErr);
    setFullPageLoading(false);
  } else {
    setFullPageLoading(false);
    setErrorTitle(title);
    setErrorDescription(description);
    setShowError(true);
  }
}

export async function deleteProceedHelper({
  deleteFiles,
  fileDetails,
  setShowConfirmModal,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setErrorTitle,
  setErrorDescription,
  setShowError,
  history,
}) {
  setShowConfirmModal(false);
  setFullPageLoading(true);
  setFullPageLoadingTitle('Deleting file');

  const {
    success,
    title = 'Something went wrong',
    description = 'Please try again later',
  } = await deleteFiles([fileDetails], []);

  if (success) {
    setFullPageLoading(false);
    history.replace('/edd');
  } else {
    setFullPageLoading(false);
    setErrorTitle(title);
    setErrorDescription(description);
    setShowError(true);
  }
}

export async function scheduleCancelInterfaceHelper({
  cancelInterface,
  cancelScheduledDeploy,
  cancelScheduledImport,
  fileDetails,
  setShowCancelSchedule,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setFileDetails,
  setErrorTitle,
  setErrorDescription,
  setShowError,
}) {
  setShowCancelSchedule(false);

  if (cancelInterface.cancelScheduleDeployment) {
    setFullPageLoading(true);
    setFullPageLoadingTitle('Canceling Scheduled Import');
    const {
      success,
      title = 'Something went wrong',
      description = 'Please try again later',
      filesScheduledForCancel = [],
    } = await cancelScheduledDeploy([fileDetails]);

    if (success) {
      setFullPageLoading(false);
      setFileDetails(filesScheduledForCancel[0]);
    } else {
      setFullPageLoading(false);
      setErrorTitle(title);
      setErrorDescription(description);
      setShowError(true);
    }
  }

  if (cancelInterface.cancelScheduleImport) {
    setFullPageLoading(true);
    setFullPageLoadingTitle('Canceling Scheduled Import');
    const {
      success,
      title = 'Something went wrong',
      description = 'Please try again later',
      filesScheduledForCancel = [],
    } = await cancelScheduledImport([fileDetails]);

    if (success) {
      setFullPageLoading(false);
      setFileDetails(filesScheduledForCancel[0]);
    } else {
      setFullPageLoading(false);
      setErrorTitle(title);
      setErrorDescription(description);
      setShowError(true);
    }
  }
}

export async function handleScheduleDeployHelper({
  scheduleDeploy,
  fileDetails,
  deployDates,
  setShowScheduleDeploy,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setFileDetails,
  setScheduleDeployData,
  setDateArr,
  setErrorTitle,
  setErrorDescription,
  setShowError,
}) {
  setShowScheduleDeploy(false);
  setFullPageLoadingTitle('Scheduling Deploy');
  setFullPageLoading(true);

  const {
    success,
    filesScheduledForDeploy = {},
    title = 'Something went wrong',
    description = 'Please try again later',
  } = await scheduleDeploy([fileDetails], deployDates);

  if (success) {
    setFileDetails(filesScheduledForDeploy[0]);
    setScheduleDeployData([]);
    setDateArr(new Array(30).fill(null));
    setFullPageLoading(false);
  } else {
    setFullPageLoading(false);
    setErrorTitle(title);
    setErrorDescription(description);
    setShowError(true);
  }
}

export async function handleScheduleImportHelper({
  scheduleImport,
  fileDetails,
  importDates,
  setShowScheduleImport,
  setFullPageLoading,
  setFullPageLoadingTitle,
  setFileDetails,
  setScheduleImportData,
  setDateArr,
  setErrorTitle,
  setErrorDescription,
  setShowError,
}) {
  setShowScheduleImport(false);
  setFullPageLoadingTitle('Scheduling Import');
  setFullPageLoading(true);

  const {
    success,
    filesScheduledForImport = {},
    title = 'Something went wrong',
    description = 'Please try again later',
  } = await scheduleImport([fileDetails], importDates);

  if (success) {
    setFileDetails(filesScheduledForImport[0]);
    setScheduleImportData([]);
    setDateArr(new Array(30).fill(null));
    setFullPageLoading(false);
  } else {
    setFullPageLoading(false);
    setErrorTitle(title);
    setErrorDescription(description);
    setShowError(true);
  }
}
